"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.REJECT_VALUE_401 = exports.BASE_URL = void 0;
// A tiny wrapper around fetch(), inspired from
// https://kentcdodds.com/blog/replace-axios-with-a-simple-custom-fetch-wrapper
// https://redux-toolkit.js.org/usage/usage-with-typescript#createasyncthunk
const react_native_1 = require("react-native");
const react_native_config_1 = __importDefault(require("react-native-config"));
const config_1 = require("../../web/config");
exports.BASE_URL = react_native_1.Platform.OS === 'web' ? config_1.BACKEND_URL : react_native_config_1.default.BACKEND_URL;
exports.REJECT_VALUE_401 = { '401': 'true' };
async function client(url, { clientBody, method, token, }, thunkApi = {}, // eslint-disable-line
clientHeaders = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
}) {
    let body = '';
    if (Object.keys(clientBody).length !== 0) {
        body = clientBody instanceof FormData ? clientBody : JSON.stringify(clientBody);
    }
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    let config = {
        method,
        headers: clientHeaders,
    };
    if (method === 'POST' || method === 'PUT') {
        config.body = body;
    }
    if (token) {
        config.headers.Authorization = `TOKEN ${token}`;
    }
    // TODO find a way to make fetch more general so we can remove this if
    // only used by web for POST payload with files
    if (react_native_1.Platform.OS === 'web' && clientBody instanceof FormData && method === 'POST') {
        const myHeaders = new Headers();
        myHeaders.append('Authorization', `TOKEN ${token}`);
        config = {
            method: 'POST',
            headers: myHeaders,
            body: clientBody,
        };
    }
    try {
        const response = await fetch(url, config);
        if (response.status === 401) {
            return thunkApi.rejectWithValue(exports.REJECT_VALUE_401);
        }
        if (response.status === 400 || response.status === 500) {
            return thunkApi.rejectWithValue((await response.json()));
        }
        return (await response.json());
    }
    catch (err) {
        let errorMessage = 'An error has occurred.';
        if (err instanceof Error) {
            errorMessage = err.message;
        }
        return thunkApi.rejectWithValue({ error: errorMessage });
    }
}
exports.default = client;
